export const STRIKE_ALERT_RECIPIENTS = ['lindsey@fitgroupusa.com', 'jasper@fitgroupusa.com'];

const escapeHtml = (value = '') => String(value)
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&#039;');

const getInstructorName = (instructor = {}) => {
  const fullName = [instructor.FirstName, instructor.LastName]
    .filter(Boolean)
    .join(' ')
    .trim();

  return fullName || instructor.Email || instructor.id || 'Instructor';
};

const formatDateTimeLA = (ms) => {
  const date = Number(ms);
  if (!Number.isFinite(date)) return 'Unknown';

  return new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Los_Angeles',
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(date));
};

const buildDroppedClassRows = (droppedClasses = []) => {
  if (!Array.isArray(droppedClasses) || droppedClasses.length === 0) {
    return '<li>No additional future classes were dropped.</li>';
  }

  return droppedClasses.map((classData) => `
    <li>
      <strong>${escapeHtml(classData.className || classData.ClassName || classData.id || 'Class')}</strong>
      <br />
      Class ID: ${escapeHtml(classData.id || '')}
      <br />
      Date: ${escapeHtml(formatDateTimeLA(classData.date || classData.Date))}
      <br />
      Facility ID: ${escapeHtml(classData.facilityId || classData.FacilityID || '')}
    </li>
  `).join('');
};

const buildEmailShell = ({ title, body }) => `
  <div style="font-family: Arial, sans-serif; background: #f6f8fb; padding: 24px;">
    <div style="max-width: 680px; margin: 0 auto; background: #ffffff; border-radius: 16px; overflow: hidden; border: 1px solid #e2e8f0;">
      <div style="background: #1b75bb; color: #ffffff; padding: 22px 26px;">
        <h1 style="margin: 0; font-size: 24px; line-height: 1.25;">${escapeHtml(title)}</h1>
      </div>
      <div style="padding: 26px; color: #1a202c; font-size: 15px; line-height: 1.55;">
        ${body}
      </div>
    </div>
  </div>
`;

export const buildStrikePausedTeamEmailPayload = ({
  instructor = {},
  actor = {},
  reason = '',
  source = 'instructor_portal',
  nowMs = Date.now(),
  strikeEligibleClassIds = [],
  droppedClasses = [],
} = {}) => {
  const instructorName = getInstructorName(instructor);
  const subject = `Instructor Strike Paused: ${instructorName}`;

  return {
    to: STRIKE_ALERT_RECIPIENTS,
    message: {
      subject,
      html: `
        <div style="font-family: Arial, sans-serif; color: #172554; line-height: 1.5;">
          <h2 style="margin: 0 0 12px;">Instructor Strike Paused</h2>
          <p>
            ${escapeHtml(instructorName)} has reached the third late-cancellation strike and was paused from the instructor portal.
          </p>
          <p><strong>Reason:</strong> ${escapeHtml(reason || 'Not provided')}</p>
          <p><strong>Instructor email:</strong> ${escapeHtml(instructor.Email || 'Not provided')}</p>
          <p><strong>Instructor phone:</strong> ${escapeHtml(instructor.Phone || 'Not provided')}</p>
          <p><strong>Submitted by:</strong> ${escapeHtml(actor.name || actor.email || 'Instructor portal')}</p>
          <p><strong>Submitted at:</strong> ${escapeHtml(formatDateTimeLA(nowMs))}</p>
          <p><strong>Strike class IDs:</strong> ${escapeHtml(strikeEligibleClassIds.join(', ') || 'None')}</p>
          <h3 style="margin: 18px 0 8px;">Future classes dropped</h3>
          <ul style="padding-left: 18px; margin-top: 0;">
            ${buildDroppedClassRows(droppedClasses)}
          </ul>
        </div>
      `,
    },
    metadata: {
      type: 'instructor_strike_paused_alert',
      instructorId: instructor.id || '',
      instructorEmail: instructor.Email || '',
      source,
      droppedClassCount: Array.isArray(droppedClasses) ? droppedClasses.length : 0,
      strikeEligibleClassIds,
      createdAt: nowMs,
    },
  };
};

export const buildStrikeAppealEmailPayload = ({
  instructor = {},
  message = '',
  nowMs = Date.now(),
} = {}) => {
  const instructorName = getInstructorName(instructor);
  const subject = `Instructor Strike Appeal: ${instructorName}`;

  return {
    to: STRIKE_ALERT_RECIPIENTS,
    message: {
      subject,
      html: buildEmailShell({
        title: subject,
        body: `
          <p><strong>${escapeHtml(instructorName)}</strong> submitted an appeal for their strike-paused account.</p>
          <p><strong>Instructor ID:</strong> ${escapeHtml(instructor.id || '')}</p>
          <p><strong>Instructor email:</strong> ${escapeHtml(instructor.Email || 'Not provided')}</p>
          <p><strong>Instructor phone:</strong> ${escapeHtml(instructor.Phone || 'Not provided')}</p>
          <p><strong>Submitted at:</strong> ${escapeHtml(formatDateTimeLA(nowMs))}</p>
          <h2 style="font-size: 18px; margin: 22px 0 8px;">Appeal message</h2>
          <p style="white-space: pre-wrap; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 12px; padding: 14px;">${escapeHtml(message || 'No message provided')}</p>
        `,
      }),
    },
    metadata: {
      type: 'instructor_strike_appeal',
      instructorId: instructor.id || '',
      instructorEmail: instructor.Email || '',
      source: 'instructor_portal',
      createdAt: nowMs,
    },
  };
};
